<template>
    <div class="shop-area mb-20">
        <div class="container">
            <div class="row">
                <!-- shop sidebar area start -->
                <shop-sidebar-area></shop-sidebar-area>
                <!-- shop sidebar area end -->
                <div class="col-xl-9 col-lg-8">
                    <div class="shop-banner mb-30">
                        <div class="banner-image">
                            <img class="banner-l" :src="slbanner" alt="">
                            <img class="banner-sm" :src="slbannersm" alt="">
                            <div class="banner-content text-center">
                                <p class="banner-text mb-30">Hurry Up! <br> Free Shipping All Order Over $99</p>
                                <router-link href="/shop" class="st-btn-d b-radius">Discover now</router-link>
                            </div>
                        </div>
                    </div>

                    <div class="product-lists-top">
                        <div class="product__filter-wrap">
                            <div class="row align-items-center">
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                                    <div class="product__filter d-sm-flex align-items-center">
                                        <div class="product__col">
                                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link"
                                                        :class="{ active: activeTab === 'FourCol' }" id="FourCol-tab"
                                                        data-bs-toggle="tab" data-bs-target="#FourCol" type="button"
                                                        role="tab" @click="activeTab = 'FourCol'"
                                                        aria-controls="FourCol"
                                                        :aria-selected="activeTab === 'FourCol' ? 'true' : 'false'">
                                                        <i class="fas fa-th"></i>
                                                    </button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link"
                                                        :class="{ active: activeTab === 'FiveCol' }" id="FiveCol-tab"
                                                        data-bs-toggle="tab" data-bs-target="#FiveCol" type="button"
                                                        tabindex="-1" @click="activeTab = 'FiveCol'" role="tab"
                                                        aria-controls="FiveCol"
                                                        :aria-selected="activeTab === 'FiveCol' ? 'true' : 'false'">
                                                        <i class="fas fa-list"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="product__result pl-60">
                                            <p> Showing 1–{{ product_data.slice(startIndex, endIndex).length }} of {{
                                                product_data.length }} results</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                                    <div class="product__filter-right d-flex align-items-center justify-content-md-end">
                                        <div class="product__sorting product__show-position ml-20">
                                            <ui-nice-select :options="[
                                                { value: 'default', text: 'Default Sorting' },
                                                { value: 'high', text: 'Low to Hight' },
                                                { value: 'low', text: 'High to Low' },
                                                { value: 'new', text: 'New Added' },
                                                { value: 'sale', text: 'On Sale' },
                                            ]" name="Select Shorting" :default-current="0"
                                                @onChange="store.handleSelectFilter" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="product_data.length === 0" class="cartmini__empty text-center mt-80 mb-80">
                        <img src="@/assets/images/product/empty-cart.png" alt="empty-cart-img" />
                        <h4>Sorry! Couldn't find the product you were looking For!!!</h4>
                        <p>Please check if you have misspelt something or try searching with other words.</p>
                        <router-link top="/shop" class="cart-btn">Continue Shopping</router-link>
                    </div>

                    <div v-else>

                        <div class="tab-content" id="productGridTabContent">
                            <div class="tab-pane fade" :class="{ 'show active': activeTab === 'FourCol' }" id="FourCol"
                                role="tabpanel" aria-labelledby="FourCol-tab">
                                <div class="tp-wrapper">
                                    <div class="row g-0">
                                        <div v-for="item in filteredProductsItems.slice(startIndex, endIndex)"
                                            :key="item.id" class="col-lg-3 col-md-4 col-sm-6">
                                            <product-single :product="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" :class="{ 'show active': activeTab === 'FiveCol' }" id="FiveCol"
                                role="tabpanel" aria-labelledby="FiveCol-tab">
                                <div class="tp-wrapper-2">
                                    <product-list-item v-for="item in filteredProductsItems.slice(startIndex, endIndex)"
                                        :key="item.id" :product="item" />
                                </div>
                            </div>
                        </div>

                        <div class="tp-pagination text-center">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="basic-pagination pt-30 pb-30">
                                        <ui-pagination :items-per-page="limit" :data="totalProducts"
                                            @handle-paginate="handlePagination" />
                                    </div>
                                </div>
                            </div>
                        </div>

                       <!--  <div class="tp-pagination text-center">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="basic-pagination pt-30 pb-30">
                                        <ui-pagination :items-per-page="8" :data="filteredProductsItems"
                                            @handle-paginate="handlePagination" />
                                    </div>
                                </div>
                            </div>
                        </div> -->



                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import slbanner from '@/assets/images/banner/sl-banner.jpg'
import slbannersm from '@/assets/images/banner/sl-banner-sm.png'
import ShopSidebarArea from '@/components/shop/sidebar/shop-sidebar-area.vue'
import ProductSingle from '@/components/product/product-single-3.vue'
import UiPagination from '@/components/ui/pagination.vue'
import ProductListItem from '@/components/product/product-list-item.vue'
// eslint-disable-next-line no-unused-vars
//import product_data from "@/data/product-data";
import { useProductFilterStore } from "@/stores/useProductFilterStore"

export default {
    name: "HeaderOne",
    components: {
        ShopSidebarArea,
        ProductSingle,
        ProductListItem,
        UiPagination
    },
    data() {
        const store = useProductFilterStore()
        return {
            slbanner,
            slbannersm,
            store,
            cate_menu: false,
            isSidebarOpen: false,
            category_data: [],
            product_data: [],
            searchText: '',
            category_value: '',
            category_options: [],
            filteredProductsItems: [],
            offset: 0, // Current offset
            limit: 12, // Items per page
            totalProducts: 0, // Total products count from backend
            startIndex : 0,
            endIndex : 12,
            activeTab: 'FourCol'
        }
    },
    methods: {
        async fetchProducts() {
            try {
                // Extract query parameters from the route
                const { category, brand, size, minPrice, maxPrice } = this.$route.query

                // Build query string dynamically
                const queryParams = new URLSearchParams()
                if (category) queryParams.append("category", category)
                if (brand) queryParams.append("brand", brand)
                if (size) queryParams.append("size", size)
                if (minPrice) queryParams.append("minPrice", minPrice)
                if (maxPrice) queryParams.append("maxPrice", maxPrice)

                // Include offset and limit for pagination
                queryParams.append("offset", this.offset)
                queryParams.append("limit", this.limit)

                // Make Axios GET request with query parameters
                const response = await this.$axios.get(`/available-products?${queryParams.toString()}`)

                // Update product data and reset pagination
                this.product_data = response.data.data
                this.filteredProductsItems = response.data.data
                this.totalProducts = response.data.total // Total count of products from backend

                // Reset pagination indices
                this.startIndex = 0
                this.endIndex = 12

            } catch (error) {
                console.error("Error fetching products:", error)
            }
        },


        async fetchCategories() {
            try {
                const response = await this.$axios.get('/web-categories')
                this.category_data = response.data.rows
                console.log(response.data)
                this.category_options = this.category_data.map(item => ({
                    value: item.cat_id,
                    text: item.cat_name,
                }))
                this.category_options.unshift({ value: "all", text: "All Category" })
            } catch (error) {
                console.error("Error fetching categories:", error)
            }
        },
        renderCategoryName(name) {
            return name.replace('&', '<br/> &')
        },
        isLastItem(index) {
            return index === this.category_data.length - 1
        },
        formatUrl(slug) {
            return slug.replace(/\s+/g, '-').toLowerCase()
        },
        handlePagination(data, start) {
            // Calculate offset from the start index
            this.offset = start
            this.fetchProducts() // Fetch new data for the current page
        }
    },
    mounted() {
        this.fetchProducts()
        this.fetchCategories()
        // Watch for changes in route query parameters
        this.$watch(
            () => this.$route.query,
            () => {
                this.fetchProducts() // Fetch products again when query changes
            },
            { immediate: true } // Ensures it runs immediately on load
        )

    }
}
</script>

<style scoped>
/* Add styles for Home page */
.banner-image .banner-sm {
    position: absolute;
    right: 22%;
    top: 50%;
    transform: translateY(-50%);
}

.cart-btn {
    background-color: #f03723
}
</style>
